import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import type { APIResponse } from "@/lib/types";

export type StatuteEstimateInput = {
  matterId: string;
  clientId: string;
  defendantId: string;
};
export type ClaimStatuteEstimate = {
  claimTypeId: string | null;
  claimTypeLabel: string | null;
  status: "supported" | "unsupported";
  suggestedDate: string | null;
  numberOfDays: number | null;
  ruleId: string | null;
  effectiveFrom: string | null;
  sourceCitation: string | null;
  reason: string | null;
};
export type MatterStatuteEstimate = StatuteEstimateInput & {
  dateOfLoss: string;
  suggestedDate: string | null;
  coverageComplete: boolean;
  results: ClaimStatuteEstimate[];
};
export const estimateMatterStatute = (input: StatuteEstimateInput) =>
  authenticatedFastApiAxiosInstance
    .post<
      APIResponse<MatterStatuteEstimate>
    >("matters/v2/statute-of-limitations-estimate", input)
    .then((response) => response.data);
